import styled from "styled-components";

export interface IJackpotWidgetAmountContainerProps {
  widgetIsMinimized?: boolean;
}

export const JackpotWidgetAmountContainer = styled.div<IJackpotWidgetAmountContainerProps>`
  width: ${({widgetIsMinimized}) => widgetIsMinimized ? "40%" : "initial"};
`;
